(function () {
    const root = document.querySelector('[data-controller="ranking"]');
    if (!root) return;

    const slots = Array.from(root.querySelectorAll('[data-ranking-target="slot"]'));
    const currentEl = root.querySelector('[data-ranking-target="current"]');
    const submitBtn = root.querySelector('[data-ranking-target="submit"]');
    const orderInput = root.querySelector('[data-ranking-target="orderInput"]');
    const itemsScript = root.querySelector('[data-ranking-target="itemsData"]');
    if (!itemsScript) return;

    let queue = JSON.parse(itemsScript.textContent || '[]');
    for (let i = queue.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [queue[i], queue[j]] = [queue[j], queue[i]];
    }

    const placements = new Map();

    function renderCurrent() {
        currentEl.innerHTML = '';
        if (queue.length === 0) {
            currentEl.classList.add('ranking__current--empty');
            return;
        }
        const item = queue[0];
        const img = document.createElement('img');
        if (item.image) img.src = item.image;
        img.alt = item.label;
        img.draggable = true;
        const label = document.createElement('span');
        label.className = 'ranking__current-label';
        label.textContent = item.label;
        currentEl.appendChild(img);
        currentEl.appendChild(label);

        img.addEventListener('dragstart', (e) => {
            e.dataTransfer.setData('text/plain', String(item.id));
        });

        let touchGhost = null;
        let ghostHalfW = 0;
        let ghostHalfH = 0;
        img.addEventListener('touchstart', (e) => {
            const touch = e.touches[0];
            touchGhost = img.cloneNode(true);
            touchGhost.classList.add('ranking__ghost');
            touchGhost.style.position = 'fixed';
            touchGhost.style.pointerEvents = 'none';
            touchGhost.style.zIndex = '9999';
            touchGhost.style.left = '-9999px';
            touchGhost.style.top = '-9999px';
            document.body.appendChild(touchGhost);
            ghostHalfW = touchGhost.offsetWidth / 2;
            ghostHalfH = touchGhost.offsetHeight / 2;
            touchGhost.style.left = (touch.clientX - ghostHalfW) + 'px';
            touchGhost.style.top = (touch.clientY - ghostHalfH) + 'px';
        }, { passive: true });

        img.addEventListener('touchmove', (e) => {
            if (!touchGhost) return;
            e.preventDefault();
            const touch = e.touches[0];
            touchGhost.style.left = (touch.clientX - ghostHalfW) + 'px';
            touchGhost.style.top = (touch.clientY - ghostHalfH) + 'px';
            const el = document.elementFromPoint(touch.clientX, touch.clientY);
            slots.forEach(s => s.classList.remove('ranking__slot--hover'));
            if (el) {
                const slot = el.closest('[data-ranking-target="slot"]');
                if (slot && slot.dataset.empty === 'true') {
                    slot.classList.add('ranking__slot--hover');
                }
            }
        }, { passive: false });

        img.addEventListener('touchend', (e) => {
            if (!touchGhost) return;
            const touch = e.changedTouches[0];
            const el = document.elementFromPoint(touch.clientX, touch.clientY);
            touchGhost.remove();
            touchGhost = null;
            slots.forEach(s => s.classList.remove('ranking__slot--hover'));
            if (el) {
                const slot = el.closest('[data-ranking-target="slot"]');
                if (slot && slot.dataset.empty === 'true') {
                    placeItem(slot, item);
                }
            }
        });
    }

    function placeItem(slot, item) {
        const pos = parseInt(slot.dataset.position, 10);
        slot.dataset.empty = 'false';
        slot.dataset.filled = 'true';
        slot.dataset.locked = 'true';
        const labelEl = slot.querySelector('.ranking__slot-label');
        labelEl.textContent = item.label;
        const thumb = slot.querySelector('.ranking__slot-thumb');
        if (item.image) thumb.style.backgroundImage = `url("${item.image}")`;

        placements.set(pos, item.id);
        queue.shift();
        renderCurrent();
        updateSubmit();
    }

    function updateSubmit() {
        if (placements.size === 10) {
            submitBtn.disabled = false;
            const ordered = [];
            for (let p = 1; p <= 10; p++) {
                ordered.push(placements.get(p));
            }
            orderInput.value = JSON.stringify(ordered);
        }
    }

    slots.forEach(slot => {
        slot.addEventListener('dragover', (e) => {
            if (slot.dataset.empty === 'true') e.preventDefault();
        });
        slot.addEventListener('drop', (e) => {
            e.preventDefault();
            if (slot.dataset.empty !== 'true') return;
            const id = parseInt(e.dataTransfer.getData('text/plain'), 10);
            if (queue.length === 0 || queue[0].id !== id) return;
            placeItem(slot, queue[0]);
        });
    });

    renderCurrent();
})();
